/**
 * IMPORTANT...
 * THis file is used only in Vue3 application.
 * Any changes made on this file should be made on vue2 also
 * Vue2 FIle: js/services/ShiftDigital/ShiftDigitalvehicles/GenesisShiftDigital.js
 *
 * Dont use any vue specific syntax code or store in this file
 * Any Clarifications contact Leela Directly
 *
 */
import { DecodeHtml } from '@/js/services/DecodeHtml';
import { ExpressPayments } from '@vue3/src/Services/Payments/ExpressPayments';
import {
  SHIFT_DIGITAL_HOME,
  SHIFT_DIGITAL_FORM_SHOWN,
  SHIFT_DIGITAL_MODAL,
  SHIFT_DIGITAL_SUBMIT_FORM,
  SHIFT_DIGITAL_VEHICLE_DETAILS,
  SHIFT_DIGITAL_VEHICLE_LISTING,
  SHIFT_DIGITAL_FORM_INITIATION,
  SHIFT_DIGITAL_LINK_CLICK,
  SHIFT_DIGITAL_TRADE_IN,
  SHIFT_DIGITAL_RESERVE_YOUR_VEHICLE,
  SHIFT_DIGITAL_CUSTOM,
  SHIFT_DIGITAL_PREOWNED_SPECIALS,
  SHIFT_DIGITAL_DEALER_SPECIALS,
  SHIFT_DIGITAL_SELL_CAR,
  SHIFT_DIGITAL_IN_PAGE,
  SHIFT_DIGITAL_TYPED_SEARCH_EVENT,
} from '@/js/services/ShiftDigital/ShiftDigitalConstants';
import ShiftDigitalService from '@vue3/src/Events/ShiftDigital/ShiftDigitalService';

export default class GenesisShiftDigital {
  layer = {};
  vin = '';
  vehicleDetails = '';
  constructor(isFormInteraction = false) {
    if (!isFormInteraction) window.formEvent = 0;
    if (window.vin) {
      this.setVin(vin);
    }
  }

  setVin(vin) {
    if (vin) {
      this.vin = vin;
    }
  }
  prepareSDLayer(pageType) {
    let zipCode = window.zip;
    let zip = '';
    if (zipCode) {
      zip = zipCode.split('-')[0];
    }
    this.sdLayer = {
      pageType: pageType,
      websiteTier: 'Tier 3',
      language: 'en',
      pageBrand: window.themeName.toLowerCase() !== 'mazda_oem' ? window.themeName : 'Mazda',
      sessionId: window.tid,
      dealerName: DecodeHtml.decodeHtml(window.clientName),
      siteTechnologyVersion: '2.2',
      dealerCity: window.city,
      dealerZipCode: zip,
      dealerState: window.state,
      trafficType: 'Typed/Bookmarked',
    };
    if (window.userDetails.zip && window.userDetails.zip !== '-1') {
      this.sdLayer.userZipCode = window.userDetails.zip;
    }
    if (window.userDetails.city && window.userDetails.city !== '-1') {
      this.sdLayer.userCity = window.userDetails.city;
    }
    if (window.userDetails.state && window.userDetails.state !== '-1') {
      this.sdLayer.userState = window.userDetails.state;
    }
  }

  // text use click event
  globalPageClickEvents(prefix) {
    if (prefix !== 'click to text') return;
    sd('dataLayer', {
      events: 'clickToText',
    });
    sd('send');
  }

  prepareSDLayerTransact(vehicles, dealType, event, fromType, isGtp, gtpValue) {
    this.sdLayer = {
      digRet: this.drVehiclesDetails(vehicles, dealType),
      pageType: 'Digital Retailing',
      events: event,
    };
    if (isGtp === 'isGtp' && window.enableGuaranteedTradeInProgram) {
      this.sdLayer['isGTP'] = gtpValue;
    }
    if (fromType) {
      this.sdLayer['formtype'] = fromType;
    }
  }
  // tagging for transact
  drVehiclesDetails(vehicleDetails, dealType) {
    if (vehicleDetails) {
      const payload = {
        priceUnlocked: 'True',
        dealId: window.tid,
        provider: 'Team Velocity',
        vehicleYear: vehicleDetails.year,
        vehicleMake: vehicleDetails.make,
        vehicleModel: vehicleDetails.model,
        vehicleVin: vehicleDetails.vin,
        vehicleStatus: this.getVehicleType(vehicleDetails.type),
      };
      if (dealType) {
        payload['dealType'] = dealType;
      }
      return payload;
    } else {
      return {
        priceUnlocked: 'True',
        dealId: window.tid,
        provider: 'Team Velocity',
        vehicleYear: '',
        vehicleMake: '',
        vehicleModel: '',
        vehicleVin: '',
        vehicleStatus: '',
      };
    }
  }

  drEvents(vehicle = '', dealType = '', event = '', fromType = '', isGtp = '', gtpValue = false) {
    this.prepareSDLayerTransact(vehicle, dealType, event, fromType, isGtp, gtpValue);
    this.layer = {};
    this.sendEvent();
  }

  drPageView(vehicle = '', dealType = '', event = '') {
    this.prepareSDLayerTransact(vehicle, dealType, event);
    this.layer = {};
    this.sendPageView();
  }

  //tagging for tradeValue tool

  tradeEvents(event, data = '', isGtp = false, gtp = '') {
    let payload = {
      tradeInSessionId: window.tid,
      tradeInProvider: 'Team Velocity',
      events: event,
      ...data,
    };
    if (gtp === 'isGtp' && window.enableGuaranteedTradeInProgram) {
      payload['isGtp'] = isGtp;
    }
    this.sdLayer = {
      ...payload,
    };
    this.layer = {};
    this.sendEvent();
  }
  async tradeEventsWithVin(event, vin = '', leadId = '') {
    let vehicleData = await ExpressPayments.getVehicleDetailsByVin(vin);
    let payload = {
      tradeInSessionId: window.tid,
      tradeInProvider: 'Team Velocity',
      events: event,
      tradeInYear: vehicleData.year,
      tradeInMake: vehicleData.make,
      tradeInModel: vehicleData.model,
    };
    if (leadId === 'null') {
      payload['tradeInLeadId'] = '';
    } else if (leadId) {
      payload['tradeInLeadId'] = leadId;
    } else {
      // No action needed for other cases.
    }

    this.sdLayer = {
      ...payload,
    };
    this.layer = {};
    this.sendEvent();
  }

  tradeFormEvents(event, data = '') {
    this.sdLayer = {
      tradeInSessionId: window.tid,
      tradeInProvider: 'provider name',
      events: event,
      ...data,
    };
    this.layer = {};
    this._fireFormEvent();
  }

  sendPageView() {
    window.sdDataLayer = { ...this.sdLayer, ...this.layer };
    sd('send', 'pageview');

    const searchKeyForGenesis = sessionStorage.getItem('sdaSearchKeyForGenesis') || null;
    if (searchKeyForGenesis) {
      setTimeout(() => {
        this.submitEvent(SHIFT_DIGITAL_TYPED_SEARCH_EVENT, {
          typedSearchContent: searchKeyForGenesis,
        });
        sessionStorage.removeItem('sdaSearchKeyForGenesis');
      }, 500);
    }
  }

  sendEvent(event) {
    if (event === 'scheduleServiceClick') {
      console.table({ EventName: 'Schedule Service', Fired: 'Yes' });
    }
    window.sdDataLayer = { ...this.sdLayer, ...this.layer };
    sd('send');
  }

  homePagePageView() {
    this.prepareSDLayer(SHIFT_DIGITAL_HOME);
    this.sendPageView();
  }

  getVehicleType(vehicle) {
    let vehicleType = window.vehicleType ? window.vehicleType : vehicle.type;
    switch (vehicleType.toLowerCase()) {
      case 'new':
        return 'New';
      case 'used':
        return 'Used';
      default:
        return 'CPO';
    }
  }

  sendVehicleDetailsObject(vehicle) {
    return {
      status: this.getVehicleType(vehicle),
      year: vehicle.year,
      make: vehicle.make,
      model: vehicle.model,
      trim: vehicle.trim,
      engine: vehicle.engine_Description,
      transmission: vehicle.transmission,
      interiorColor: vehicle.interiorColor,
      exteriorColor: vehicle.exteriorColor,
      vin: vehicle.vin,
      msrp: vehicle.msrp,
      driveTrain: vehicle.drivetrain,
      displayedPrice: window.displayedFinalPrice
        ? window.displayedFinalPrice
        : vehicle.sellingPrice,
      fuelType: vehicle.fuel_Type ? ShiftDigitalService.filterFuelTypes(vehicle.fuel_Type) : '',
    };
  }

  async vehicleDetailsPageView(vin = '', finalPrice = 0) {
    let vehicleDetails = '';
    if (vin) {
      let vehicle = await ExpressPayments.getVehicleDetails(vin);
      if (vehicle) {
        vehicleDetails = this.sendVehicleDetailsObject(vehicle);
        vehicleDetails.displayedPrice = finalPrice;
      }
    } else {
      vehicleDetails = {
        status: window.vehicleType,
        year: window.year,
        make: window.make,
        model: window.model,
        trim: window.trim,
        // exteriorColor: 'dont have data in window',
      };
    }

    this.prepareSDLayer(SHIFT_DIGITAL_VEHICLE_DETAILS);
    this.layer = {
      trafficType: 'Typed/Bookmarked',
      vehicleDetails,
    };
    this.sendPageView();
  }
  contactUsClick(event, data) {
    console.table({ EventName: event, Fired: 'Yes' });
    this.sdLayer = { ...data, ...{ event } };
    this.layer = {};
    this.sendEvent(event);
  }
  listingPageView() {
    this.prepareSDLayer(SHIFT_DIGITAL_VEHICLE_LISTING);
    this.layer = {};
    this.sendPageView();
  }

  specialsPageView(pageType) {
    let pageTypeName = '';
    if (pageType === SHIFT_DIGITAL_SELL_CAR) {
      pageTypeName = SHIFT_DIGITAL_TRADE_IN;
    } else if (pageType === SHIFT_DIGITAL_RESERVE_YOUR_VEHICLE) {
      pageTypeName = SHIFT_DIGITAL_CUSTOM;
    } else if (pageType === SHIFT_DIGITAL_PREOWNED_SPECIALS) {
      pageTypeName = SHIFT_DIGITAL_DEALER_SPECIALS;
    } else {
      pageTypeName = pageType;
    }
    this.prepareSDLayer(pageTypeName);
    this.layer = {};
    this.sendPageView();
  }

  customPageView(pageType) {
    this.specialsPageView(pageType);
  }

  initiateFormEventsTransact(event, formType) {
    this.sdLayer = {
      events: event,
      formtype: formType,
    };
    this.layer = {};
    this._fireFormEventTransact();
  }

  async _fireFormEventTransact() {
    let vehicleDetail = await ExpressPayments.getVehicleDetails(window.paymentsvin);
    this.sdLayer.digRet = this.drVehiclesDetails(vehicleDetail);
    this.sendEvent();
  }
  initiateFormEvents(formType) {
    this.sdLayer = {
      events: SHIFT_DIGITAL_FORM_INITIATION,
      formType,
      displayType:
        sessionStorage.getItem('genesisDisplayType') === 'in-page'
          ? SHIFT_DIGITAL_IN_PAGE
          : SHIFT_DIGITAL_MODAL,
    };
    this.layer = {};
    this._fireFormEvent();
    this.setFormType(formType);
  }

  _fireFormEvent() {
    if (!this.vin) {
      this.sendEvent();
      return;
    }

    if (!this.vehicleDetails) {
      ExpressPayments.vehicleDetails(this.vin).then((response) => {
        this.vehicleDetails = response.data;
        this.sdLayer.formVehicle = this.sendVehicleDetailsObject(this.vehicleDetails);
        this.sendEvent();
      });
    } else {
      this.sdLayer.formVehicle = this.sendVehicleDetailsObject(this.vehicleDetails);
      this.sendEvent();
    }
  }

  initiateForm(formType, displayType = '') {
    if (displayType) sessionStorage.setItem('genesisDisplayType', displayType);
    else sessionStorage.removeItem('genesisDisplayType');

    this.sdLayer = {
      events: SHIFT_DIGITAL_FORM_SHOWN,
      formType,
      displayType: displayType === 'in-page' ? SHIFT_DIGITAL_IN_PAGE : SHIFT_DIGITAL_MODAL,
    };
    this.layer = {};

    this._fireFormEvent();
  }

  async submitFormEvent(leadId, formType, payload = {}) {
    this.sdLayer = {
      leadId,
      formType,
      displayType:
        sessionStorage.getItem('genesisDisplayType') === 'in-page'
          ? SHIFT_DIGITAL_IN_PAGE
          : SHIFT_DIGITAL_MODAL,
      leadType: 'lead',
      events: SHIFT_DIGITAL_SUBMIT_FORM,
      ...payload,
    };
    if (this.vehicleDetails) {
      this.sdLayer.formVehicle = this.sendVehicleDetailsObject(this.vehicleDetails);
    } else if (this.vin) {
      let vehicle = await ExpressPayments.getVehicleDetails(this.vin);
      if (vehicle) {
        this.sdLayer.formVehicle = this.sendVehicleDetailsObject(vehicle);
      }
    } else {
      //No action needed for other cases
    }
    this.layer = {};
    this.sendEvent();
  }

  submitEvent(events, data) {
    if (events === 'getDirections' && window.accountId === '73819') {
      console.table({ EventName: 'getDirections', Fired: 'Yes' });
    }
    this.sdLayer = { ...data, ...{ events } };
    this.layer = {};
    this.sendEvent(events);
  }

  filterSearchEvent(pageType) {
    let selectedFilters = JSON.parse(window.selectedFilters);
    let status;
    if (window.genesisCPOBadgefromSRP || window.inventoryType?.split(',').length > 1) {
      status = 'mixed';
    } else {
      status = selectedFilters.Type ? selectedFilters.Type : 'All';
    }
    this.sdLayer = {
      countSearchResults: window.resultCount,
      filterSearch: {
        status: status,
        year: selectedFilters.Years ? selectedFilters.Years : 'All',
        make: selectedFilters.Makes ? selectedFilters.Makes : 'All',
        model: selectedFilters.Models ? selectedFilters.Models : 'All',
        trim: selectedFilters.Trims ? selectedFilters.Trims : 'All',
        color: selectedFilters.Colors ? selectedFilters.Colors : 'All',
        driveTrain: selectedFilters.DriveTrains ? selectedFilters.DriveTrains : 'All',
        minPrice: selectedFilters.PaymentMin ? selectedFilters.PaymentMin : 'All',
        maxPrice: selectedFilters.PaymentMax ? selectedFilters.PaymentMax : 'All',
        bodyStyle: selectedFilters.VehicleTypes ? selectedFilters.VehicleTypes : 'All',
        features: 'All',
      },
      events: pageType,
    };
    this.layer = {};
    this.sendEvent();
  }

  linkClick(location, linkType) {
    this.layer = {
      events: SHIFT_DIGITAL_LINK_CLICK,
      linkType: linkType,
      location: location,
    };
    this.sendEvent();
  }

  chatImpressionEvent() {
    this.layer = {
      chatProfitCenter: 'sales',
      chatType: 'chat',
      chatSessionId: window.tid,
      chatProvider: 'Team velocity',
      events: 'chatImpression',
    };
    this.sendEvent();
  }

  chatClickEvent() {
    this.layer = {
      chatProfitCenter: 'sales',
      chatType: 'chat',
      chatSessionId: window.tid,
      chatProvider: 'Team velocity',
      events: 'chatClick',
    };
    this.sendEvent();
  }
  chatMessageEvent(message = '') {
    this.layer = {
      chatProfitCenter: 'sales',
      chatType: 'chat',
      chatSessionId: window.tid,
      chatProvider: 'Team Velocity',
      chatMessageType: 'agent',
      chatMessageContent: message,
      events: 'chatUserMessage',
    };
    this.sendEvent();
  }
  chatLeadEvent(leadId) {
    this.layer = {
      chatProfitCenter: 'sales',
      chatType: 'chat',
      chatSessionId: window.tid,
      chatProvider: 'Team Velocity',
      chatLeadId: leadId,
      events: 'chatLead',
    };
    this.sendEvent();
  }
  chatClosedsdEvent() {
    this.layer = {
      chatProfitCenter: 'sales',
      chatType: 'chat',
      chatSessionId: window.tid,
      chatProvider: 'Team Velocity',
      events: 'chatClosed',
    };
    this.sendEvent();
  }
  setFormType(formType) {
    if (formType) sessionStorage.setItem('genesisFormType', formType);
  }
  async formInteractionEvent(formObj, vin = '') {
    this.layer = {
      formType: sessionStorage.getItem('genesisFormType') || formObj.formType || '',
      displayType:
        sessionStorage.getItem('genesisDisplayType') === 'in-page'
          ? SHIFT_DIGITAL_IN_PAGE
          : SHIFT_DIGITAL_MODAL,
      events: 'formFieldInteraction',
      formFieldName: formObj.element_title,
      ...(vin && {
        formVehicle: this.sendVehicleDetailsObject(await ExpressPayments.getVehicleDetails(vin)),
      }),
    };
    this.sendEvent();
  }
}
